module.exports = __webpack_public_path__ + "img/empty@3x.1e164b7b.png";